export default "__VITE_ASSET__CdGH3AHv__"